import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const faqs = [{
    q: '¿Sirve para cualquier mercado?',
    a: 'Sí: es un sistema de disciplina y ejecución aplicable a crypto, forex, índices y acciones. Las reglas de comportamiento son universales.'
  }, {
    q: '¿Incluye estrategia?',
    a: 'No. Este ebook hace que la estrategia que YA usas sea ejecutable. Se enfoca en la gestión de ti mismo, no del gráfico.'
  }, {
    q: '¿Cuándo lo recibo?',
    a: 'Justo después de pagar recibirás un correo con el enlace de descarga inmediata (PDF).'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section background="dark" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-3xl font-bold text-white text-center mb-12" data-id="element-29">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-900 border border-slate-800 rounded-lg overflow-hidden" data-id="element-31">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-32">
                <span className="font-semibold text-white" data-id="element-33">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-slate-400" data-id="element-34" /> : <ChevronDown className="h-5 w-5 text-slate-400" data-id="element-35" />}
              </button>

              <AnimatePresence data-id="element-36">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-37">
                    <div className="p-5 pt-0 text-slate-400 border-t border-slate-800/50" data-id="element-38">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}